import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import AccionesClientesCesantes from "../components/accionesCesantes";
import { ClientesCesantesDTO, ModificarCesanteDTO } from "../models/clientesCesantes";


interface IProps {
    controlTabla: any;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
    setcesanteEditar: React.Dispatch<React.SetStateAction<ClientesCesantesDTO | undefined>>;
    isEdit: (value: boolean) => void;

}

export function useColumns({ controlTabla, setModalDetalle, setcesanteEditar, isEdit }: IProps) {
    const COLUMNS: columns<ClientesCesantesDTO>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesClientesCesantes
                    cesanteEditar={row}
                    controlTabla={controlTabla}
                    setcesanteEditar={setcesanteEditar}
                    setModalDetalle={setModalDetalle}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'N° Operación',
            selector: (row) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'OMD',
            selector: (row) => row.omd,
            sortable: true,
            sortField: 'omd',
            wrap: true,
            export: true
        },
        {
            name: 'RUT',
            selector: (row) => row.rut,
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true
        },

        {
            name: 'Fecha inicio',
            selector: (row) => row.fechaInicio ? Conversiones.fechaCortaFormat(row.fechaInicio.toString()) : "",
            sortable: true,
            sortField: 'fechaInicio',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Fecha término',
            selector: (row) => row.fechaTermino ? Conversiones.fechaCortaFormat(row.fechaTermino.toString()) : "",
            sortable: true,
            sortField: 'fechaTermino',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Detalle',
            selector: (row) => row.detalle,
            sortable: true,
            sortField: 'detalle',
            wrap: true,
            export: true
        },
        {
            name: 'Fecha finiquito',
            selector: (row) => row.fechaFiniquito ? Conversiones.fechaCortaFormat(row.fechaFiniquito.toString()) : "",
            sortable: true,
            sortField: 'fechaFiniquito',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Activo',
            selector: (row) => row.activo,
            sortable: true,
            sortField: 'activo',
            wrap: true,
            export: true
        },
             {
            name: 'Usuario',
            selector: (row) => row.usuario,
            sortable: true,
            sortField: 'usuario',
            wrap: true,
            export: true
        },
        {
            name: 'Fecha última modificación',
            selector: (row) => row.fechaUltimodificacion ? Conversiones.fechaCortaFormat(row.fechaUltimodificacion.toString()) : "",
            sortable: true,
            sortField: 'fechaUltimodificacion',
            wrap: true,
            export: true,
            alling: 'left'
        },
    ];
    return { COLUMNS };

}